// Mock data voor Nikita's Reizen op Maat

export const pakketReizen = [
  {
    id: 1,
    naam: "Mauritius & Madagaskar Combi",
    beschrijving: "18 dagen paradijselijke stranden op Mauritius gecombineerd met unieke wildlife en natuur in Madagaskar. De perfecte mix van ontspanning en avontuur.",
    prijs: "vanaf €3.299",
    duur: "18 dagen",
    afbeelding: "https://images.unsplash.com/photo-1603477849227-705c424d1d80",
    hoogtepunten: ["Mauritius Stranden", "Madagaskar Wildlife", "Snorkelen", "Lemuren Spotten"],
    type: "combi-trip"
  },
  {
    id: 2,
    naam: "Sri Lanka Ontdekkingsreis",
    beschrijving: "14 dagen door het prachtige Sri Lanka. Oude tempels, theeplantages, wildlife safari's en gouden stranden.",
    prijs: "vanaf €1.899",
    duur: "14 dagen",
    afbeelding: "https://images.unsplash.com/photo-1535262412227-85541e910204",
    hoogtepunten: ["Sigiriya Rots", "Kandy Tempel", "Yala Safari", "Mirissa Beach"],
    type: "rondreis"
  },
  {
    id: 3,
    naam: "Thailand Compleet",
    beschrijving: "16 dagen van Bangkok tot de eilanden. Tempels, jungle, bergvolken en paradijselijke stranden in één reis.",
    prijs: "vanaf €1.999",
    duur: "16 dagen",
    afbeelding: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
    hoogtepunten: ["Bangkok Tempels", "Chiang Mai Olifanten", "Phi Phi Islands", "Full Moon Party"],
    type: "rondreis"
  },
  {
    id: 4,
    naam: "Griekenland Eiland Roadtrip",
    beschrijving: "15 dagen eilandhoppen door de Cycladen. Mykonos, Santorini, Naxos en Paros - witte huisjes, blauwe koepels en azuurblauwe zee.",
    prijs: "vanaf €1.699",
    duur: "15 dagen",
    afbeelding: "https://images.unsplash.com/photo-1601581875039-e899893d520c",
    hoogtepunten: ["Mykonos Stranden", "Santorini Sunset", "Naxos Dorpen", "Griekse Keuken"],
    type: "rondreis"
  },
  {
    id: 5,
    naam: "Namibië & Mozambique Avontuur",
    beschrijving: "20 dagen Afrika op zijn best. Namibië's rode woestijnen en wilde dieren, gevolgd door Mozambique's ongerepte stranden.",
    prijs: "vanaf €3.599",
    duur: "20 dagen",
    afbeelding: "https://images.pexels.com/photos/1705252/pexels-photo-1705252.jpeg",
    hoogtepunten: ["Sossusvlei Duinen", "Etosha Safari", "Mozambique Beaches", "Duiken & Snorkelen"],
    type: "combi-trip"
  },
  {
    id: 6,
    naam: "Italië Klassiek",
    beschrijving: "14 dagen door het prachtige Italië. Rome, Florence, Venetië en de Amalfikust - kunst, cultuur en dolce vita.",
    prijs: "vanaf €2.299",
    duur: "14 dagen",
    afbeelding: "https://images.unsplash.com/photo-1705519617845-13d13049d42f",
    hoogtepunten: ["Colosseum Rome", "Uffizi Florence", "Venetië Gondels", "Amalfi Coast"],
    type: "rondreis"
  },
  {
    id: 7,
    naam: "Spanje & Portugal Hoogtepunten",
    beschrijving: "17 dagen door Iberië. Barcelona, Madrid, Porto en Lissabon - Gaudí, flamenco, port en pastéis de nata.",
    prijs: "vanaf €1.699",
    duur: "17 dagen",
    afbeelding: "https://images.unsplash.com/photo-1605130284535-11dd9eedc58a",
    hoogtepunten: ["Sagrada Familia", "Prado Museum", "Porto Wijnproeverij", "Lissabon Trams"],
    type: "combi-trip"
  },
  {
    id: 8,
    naam: "Scandinavië Natuurwonder",
    beschrijving: "14 dagen door Noorwegen, Zweden en Finland. Fjorden, noorderlicht, midnachtzon en Scandinavische design.",
    prijs: "vanaf €2.199",
    duur: "14 dagen",
    afbeelding: "https://images.unsplash.com/photo-1618416784914-9d0592219047",
    hoogtepunten: ["Noorse Fjorden", "Stockholm", "Noorderlicht", "Sauna Ervaring"],
    type: "rondreis"
  },
  {
    id: 9,
    naam: "IJsland Ring Road",
    beschrijving: "12 dagen rondom IJsland. Watervallen, geisers, gletsjers, vulkanen en het noorderlicht - pure natuurkracht.",
    prijs: "vanaf €1.999",
    duur: "12 dagen",
    afbeelding: "https://images.unsplash.com/photo-1554366347-897a5113f6ab",
    hoogtepunten: ["Blue Lagoon", "Golden Circle", "Jökulsárlón", "Noorderlicht Jacht"],
    type: "rondreis"
  },
  {
    id: 10,
    naam: "Balkans Verborgen Parels",
    beschrijving: "16 dagen door Kroatië, Montenegro en Albanië. Dubrovnik, Kotor Bay en Albanese Rivièra - kristalhelder water en authentieke dorpen.",
    prijs: "vanaf €1.499",
    duur: "16 dagen",
    afbeelding: "https://images.unsplash.com/photo-1594661745200-810105bcf054",
    hoogtepunten: ["Dubrovnik", "Kotor Bay", "Plitvice Meren", "Albanese Stranden"],
    type: "rondreis"
  },
  {
    id: 11,
    naam: "Costa Rica Pura Vida",
    beschrijving: "15 dagen natuuravontuur in Costa Rica. Regenwouden, vulkanen, wilde dieren en Caribische stranden - puur leven!",
    prijs: "vanaf €2.599",
    duur: "15 dagen",
    afbeelding: "https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a",
    hoogtepunten: ["Arenal Vulkaan", "Regenwoud Zip-line", "Luiaards & Toucans", "Caribische Stranden"],
    type: "rondreis"
  },
  {
    id: 12,
    naam: "En Nog Veel Meer...",
    beschrijving: "Onze expertise reikt veel verder! Van Japan tot Peru, van Marokko tot Nieuw-Zeeland - neem contact op voor jouw droombest emming.",
    prijs: "op aanvraag",
    duur: "flexibel",
    afbeelding: "https://images.unsplash.com/photo-1769981639118-e63f99901eeb",
    hoogtepunten: ["Wereldwijd", "Op Maat", "Persoonlijk Advies", "Alle Budgetten"],
    type: "custom"
  }
];

export const diensten = [
  {
    id: 1,
    titel: "Reizen op Maat",
    beschrijving: "Jouw reis, jouw wensen. Wij stellen een volledig persoonlijke reis samen die perfect bij jou past.",
    icon: "Plane"
  },
  {
    id: 2,
    titel: "Rondreizen Planning",
    beschrijving: "Plan je eigen rondreis met onze interactieve tool. Kies bestemmingen, activiteiten en accommodaties.",
    icon: "Map"
  },
  {
    id: 3,
    titel: "Reisadvies",
    beschrijving: "Twijfel je nog? Wij helpen je met inspiratie en professioneel advies voor jouw perfecte reis.",
    icon: "Compass"
  },
  {
    id: 4,
    titel: "Maatwerkreizen",
    beschrijving: "Ontdek onze zorgvuldig samengestelde maatwerkreizen naar de mooiste bestemmingen wereldwijd.",
    icon: "Package"
  }
];

export const reisStappen = [
  {
    stap: 1,
    titel: "Deel je wensen",
    beschrijving: "Vertel ons over je droomreis, budget en voorkeuren"
  },
  {
    stap: 2,
    titel: "Persoonlijk voorstel",
    beschrijving: "Wij maken een op maat gemaakt reisvoorstel voor jou"
  },
  {
    stap: 3,
    titel: "Samen afstemmen",
    beschrijving: "We verfijnen de reis tot alles perfect is"
  },
  {
    stap: 4,
    titel: "Zorgeloos genieten",
    beschrijving: "Alles is geregeld, jij hoeft alleen nog te genieten!"
  }
];

export const bestemmingen = {
  europa: [
    "Portugal", "Spanje", "Italië", "Griekenland", "Kroatië",
    "Malta", "Cyprus", "IJsland", "Noorwegen", "Zweden",
    "Finland", "Denemarken", "Oostenrijk", "Zwitserland", 
    "Frankrijk", "Nederland", "België", "Duitsland",
    "Tsjechië", "Polen", "Slovenië", "Ierland", "Schotland",
    "Montenegro", "Albanië", "Roemenië", "Bulgarije"
  ],
  azie: [
    "Japan", "Zuid-Korea", "Singapore", "Dubai (VAE)",
    "Thailand", "Vietnam", "Cambodja", "Laos",
    "Maleisië", "Indonesië (Bali)", "Filippijnen",
    "Sri Lanka", "Nepal", "Bhutan", "Taiwan",
    "Jordanië", "Oman", "Georgië", "Armenië"
  ],
  afrika: [
    "Marokko", "Tunesië", "Egypte", "Zuid-Afrika",
    "Namibië", "Botswana", "Tanzania", "Kenia",
    "Rwanda", "Madagaskar", "Mozambique", "Seychellen",
    "Mauritius", "Zanzibar", "Kaapverdië"
  ],
  amerika: [
    "Canada", "Verenigde Staten (VS)", "Mexico",
    "Costa Rica", "Panama", "Colombia", "Ecuador",
    "Peru", "Chili", "Argentinië", "Brazilië",
    "Uruguay", "Bolivia"
  ],
  oceanie: [
    "Nieuw-Zeeland", "Australië", "Fiji"
  ]
};

export const accommodatieTypes = [
  "Budget Hotel", "Middenklasse Hotel", "Luxe Resort", 
  "Boutique Hotel", "Villa", "Bungalow", "Hostel"
];

export const activiteiten = [
  "Strandbezoek & Ontspanning",
  "Snorkelen & Duiken",
  "Wandelen & Trekking",
  "Bergbeklimmen",
  "Cultuur & Tempels",
  "Wildlife Safari",
  "Foodtours & Lokale Keuken",
  "Watersport (surfen, kitesurfen)",
  "Yoga & Wellness",
  "Lokale Markten bezoeken",
  "Nachtleven & Uitgaan",
  "Fietsen & Mountainbiken",
  "Fotografie Tours",
  "Extreme Sporten (bungeejump, skydiven)",
  "Wijn- & Bierproeverijen",
  "Museumbezoeken",
  "Shopping"
];
